import ActionsBuilder from '../../../../utils/actions/ActionsBuilder';

export const IDENTIFIER = '[COMPANIES]';

export default {
    ...ActionsBuilder.buildList(IDENTIFIER, false, true, true)
};
